// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1TgzU","rootSmall":"AddTileButton_rootSmall__1dQoW"};